import { render, staticRenderFns } from "./CreateFloatingPopup.vue?vue&type=template&id=87511556"
import script from "./CreateFloatingPopup.vue?vue&type=script&lang=js"
export * from "./CreateFloatingPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports